<template>
  <div class="legal-wrap" :class="isZh ? 'lang-cn' : 'lang-it'">
    <Head></Head>
    <div class="page">
      <div class="doc-header">
        <!-- Rakumart 服务条款 -->
        <h1 class="doc-title doc-title-single">
          {{ $fanyi("Rakumart 服务条款") }}
        </h1>
        <div class="doc-sub">
          ADVANCING DIGITAL TRADE CO., LIMITED · www.rakumart.it
        </div>
      </div>

      <div class="info-card">
        <div class="info-row">
          <div class="info-label">
            <span class="it">Fornitore</span>
            <span class="cn">供应商</span>
          </div>
          <div class="info-value">ADVANCING DIGITAL TRADE CO., LIMITED</div>
        </div>
        <div class="info-row">
          <div class="info-label">
            <span class="it">E-mail di contatto</span>
            <span class="cn">联系邮箱</span>
          </div>
          <div class="info-value">
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>
          </div>
        </div>
      </div>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">1</span>
          <span class="t">
            <span class="it"
              >Parti e accettazione delle condizioni generali</span
            >
            <span class="cn">合同双方及通用条款的接受</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Da una parte, il fornitore dei prodotti, ADVANCING DIGITAL TRADE
            CO., LIMITED (di seguito, "rakumart.it"), indirizzo e-mail
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>, (di
            seguito anche "il prestatore"), titolare del sito web
            <a href="/">www.rakumart.it</a>, espone il presente documento
            contrattuale che regolerà l'acquisto di prodotti tramite il suddetto
            sito web.
          </p>
          <p class="cn">
            一方面，产品供应商 ADVANCING DIGITAL TRADE CO., LIMITED（以下简称
            "rakumart.it"），电子邮箱
            <a href="mailto:service@rakumart.it">service@rakumart.it</a
            >（以下亦称 "服务提供方"），系网站 <a href="/">www.rakumart.it</a>
            的所有者，现公布本合同文件，以规范通过上述网站购买产品的行为。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Dall'altra parte, l'Utente – Cliente (di seguito "l'Utente"),
            registrato sul sito web mediante nome utente e password, dei quali
            ha piena responsabilità d'uso e custodia, essendo responsabile della
            veridicità dei dati personali forniti al prestatore.
          </p>
          <p class="cn">
            另一方面，用户——客户（以下简称
            "用户"）已在网站上通过用户名和密码完成注册，对其使用与保管承担全部责任，并对向服务提供方所提供的个人数据的真实性负责。
          </p>
        </div>
        <div class="bi">
          <p class="it lead">
            Le parti accettano il presente documento, e ciò comporta che
            l'Utente:
          </p>
          <p class="cn">双方接受本文件，这意味着用户：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >ha letto, inteso e compreso quanto qui esposto;</span
            >
            <span class="cn">已阅读、理解并明白本文所载内容；</span>
          </li>
          <li>
            <span class="it"
              >è una persona maggiorenne e dispone della capacità sufficiente
              per contrattare;</span
            >
            <span class="cn">为成年人，并具备足够的缔约能力；</span>
          </li>
          <li>
            <span class="it">assume tutti gli obblighi qui previsti;</span>
            <span class="cn">承担本文规定的全部义务；</span>
          </li>
          <li>
            <span class="it"
              >ha letto e accetta le presenti condizioni generali di contratto
              dal momento in cui acquista qualsiasi prodotto offerto.</span
            >
            <span class="cn"
              >自购买任何所提供产品之时起，已阅读并接受本通用合同条款。</span
            >
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            Il presente documento può essere stampato e conservato dagli Utenti.
            Il prestatore mette a disposizione degli stessi l'indirizzo e-mail
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>
            affinché possano formulare qualsiasi domanda relativa alle presenti
            condizioni.
          </p>
          <p class="cn">
            用户可打印并保存本文件。服务提供方向用户提供电子邮箱
            <a href="mailto:service@rakumart.it">service@rakumart.it</a
            >，以便就本条款提出任何疑问。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Le presenti condizioni avranno validità a tempo indeterminato e
            saranno applicabili a tutti gli acquisti effettuati tramite il sito
            web del prestatore.
          </p>
          <p class="cn">
            本条款自公布之日起长期有效，适用于通过服务提供方网站进行的所有购买。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il prestatore si riserva il diritto di modificare unilateralmente le
            presenti Condizioni Generali, senza che ciò possa incidere sui beni
            o sulle promozioni acquistati prima della modifica, al fine di
            migliorare i prodotti offerti. In ogni caso, prima di acquistare i
            prodotti, è necessario consultare le presenti condizioni generali.
          </p>
          <p class="cn">
            服务提供方保留单方面修改本通用条款的权利，且该修改不影响修改前已购买的商品或促销活动，旨在改进所提供的产品。无论如何，在购买产品之前，请务必查阅本通用条款。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Si consiglia di conservare una copia dei dati contenuti nei prodotti
            acquistati. ADVANCING DIGITAL TRADE CO., LIMITED non è responsabile
            di eventuali perdite di dati, file o di qualsiasi danno derivante da
            un mancato backup da parte del titolare dei dati.
          </p>
          <p class="cn">
            建议保存所购产品中包含的数据副本。ADVANCING DIGITAL TRADE CO.,
            LIMITED
            对因数据主体未进行备份而导致的数据、文件丢失或任何损害不承担责任。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il prestatore non è responsabile delle conseguenze che possano
            derivare da un uso improprio dei prodotti in vendita sul sito web.
          </p>
          <p class="cn">
            服务提供方对因不当使用网站上销售的产品而可能产生的后果不承担责任。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            La responsabilità civile di ADVANCING DIGITAL TRADE CO., LIMITED per
            i prodotti forniti è limitata all'importo degli stessi. L'Utente
            rinuncia a reclamare qualsiasi responsabilità nei confronti del
            prestatore, per qualsiasi motivo, in caso di insoddisfazione
            relativa ai prodotti acquistati sul sito
            <a href="/">www.rakumart.it</a>, nonché per eventuali
            malfunzionamenti, lentezza di accesso o errori nell'accesso al sito
            web, incluse perdite di dati o altre informazioni presenti nel
            computer o nella rete dell'Utente che accede al sito web.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            对所提供产品的民事责任以产品金额为限。用户对在网站
            <a href="/">www.rakumart.it</a>
            上购买的产品感到不满，或因网站故障、访问缓慢、访问错误（包括访问用户计算机或网络中存储的数据或其他信息时发生的数据丢失）而向服务提供方主张任何责任，均予以放弃。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">2</span>
          <span class="t">
            <span class="it">Oggetto del contratto</span>
            <span class="cn">合同标的</span>
          </span>
        </h2>
        <div class="group-label">
          <span class="it">2.1 Ambito di applicazione</span>
          <span class="cn">2.1 适用范围</span>
        </div>
        <div class="bi">
          <p class="it">
            Il presente contratto ha per oggetto la regolamentazione del
            rapporto contrattuale di compravendita sorto tra il prestatore e
            l'Utente nel momento in cui quest'ultimo accetta le presenti
            condizioni di acquisto durante il processo di acquisto online,
            selezionando l'apposita casella. Le presenti condizioni generali si
            applicheranno a partire dal giorno in cui viene effettuato l'ordine.
          </p>
          <p class="cn">
            本合同旨在规范服务提供方与用户之间在后者于在线购买过程中勾选相应选项并接受本购买条款时成立的买卖合同关系。本通用条款自下单之日起适用。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il rapporto contrattuale di compravendita comporta la consegna, a
            fronte di un prezzo determinato e pubblicamente indicato tramite il
            sito web, di un prodotto specifico.
          </p>
          <p class="cn">
            买卖合同关系意味着在网站公开标明的确定价格下，交付特定产品。
          </p>
        </div>
        <div class="group-label">
          <span class="it">2.2 Territorio di applicazione</span>
          <span class="cn">2.2 适用区域</span>
        </div>
        <div class="bi">
          <p class="it">
            Il negozio online <a href="/">www.rakumart.it</a> è attivo su tutto
            il territorio nazionale.
          </p>
          <p class="cn">
            在线商店 <a href="/">www.rakumart.it</a> 在意大利全国境内均可使用。
          </p>
        </div>
        <div class="group-label">
          <span class="it">2.3 Capacità di contrattare</span>
          <span class="cn">2.3 缔约能力</span>
        </div>
        <div class="bi">
          <p class="it">
            Per poter effettuare un ordine, l'Utente deve essere maggiorenne e
            avere la capacità giuridica di contrattare.
          </p>
          <p class="cn">
            用户须为成年人并具备法律上的缔约能力，方可下单。
          </p>
        </div>
        <div class="group-label">
          <span class="it">2.4 Accettazione del cliente</span>
          <span class="cn">2.4 客户接受</span>
        </div>
        <div class="bi">
          <p class="it">
            La convalida di un ordine tramite il sito web viene effettuata
            mediante posta elettronica e implica altresì l'accettazione
            automatica delle condizioni generali. Le presenti condizioni sono
            disponibili sul sito
            <a href="/">www.rakumart.it</a> oppure, su richiesta, possono essere
            inviate via e-mail all'indirizzo sopra indicato.
          </p>
          <p class="cn">
            通过网站确认订单将以电子邮件方式进行，并同时意味着自动接受本通用条款。本条款可在网站
            <a href="/">www.rakumart.it</a>
            上查阅；如有需要，也可应要求发送至上述电子邮箱。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">3</span>
          <span class="t">
            <span class="it">Prezzi</span>
            <span class="cn">价格</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Tutti i prezzi mostrati sul sito web di ADVANCING DIGITAL TRADE CO.,
            LIMITED, all'indirizzo <a href="/">www.rakumart.it</a>, non
            includono IVA né spese di spedizione.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED 网站
            <a href="/">www.rakumart.it</a> 上显示的所有价格均不含增值税及运费。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Qualora in futuro vengano effettuate consegne internazionali e
            l'ordine debba essere spedito a un indirizzo di consegna situato al
            di fuori dell'Unione Europea, si tenga presente che l'IVA verrà
            detratta al momento dell'acquisto o prima, a seconda del Paese in
            cui il prodotto dovrà essere consegnato.
          </p>
          <p class="cn">
            若将来进行国际配送且订单须发往欧盟以外的收货地址，请注意增值税将在购买时或之前予以扣除，具体取决于产品交付所在国家。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Nota: se l'ordine viene spedito a un indirizzo di consegna situato
            fuori dall'UE, potrebbe essere soggetto a dazi doganali e imposte,
            il cui pagamento dovrà essere effettuato quando la spedizione
            raggiunge l'indirizzo di consegna. Il Cliente sarà responsabile del
            pagamento di tali importi relativi a dazi doganali e imposte. Si
            precisa che ADVANCING DIGITAL TRADE CO., LIMITED non ha alcun
            controllo su tali costi aggiuntivi. ADVANCING DIGITAL TRADE CO.,
            LIMITED raccomanda di richiedere ulteriori informazioni presso il
            Servizio Doganale.
          </p>
          <p class="cn">
            注：若订单发往欧盟以外的收货地址，可能须缴纳关税和税费，且应在货物抵达收货地址时支付。客户须自行承担上述关税和税费。ADVANCING
            DIGITAL TRADE CO., LIMITED 对这些额外费用没有任何控制权。ADVANCING
            DIGITAL TRADE CO., LIMITED 建议向海关部门咨询更多信息。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il prezzo non include le spese di spedizione, che saranno applicate
            al momento dell'acquisto del prodotto.
          </p>
          <p class="cn">
            价格不含运费，运费将在购买产品时收取。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            I prezzi dei nostri prodotti sono soggetti a modifiche senza
            preavviso. Ci riserviamo il diritto di modificare o interrompere il
            Servizio, o qualsiasi parte o contenuto dello stesso, senza
            preavviso e in qualsiasi momento. Non saremo responsabili nei
            confronti dell'Utente né di terzi per eventuali modifiche o
            variazioni di prezzo. La modifica del prezzo non inciderà sugli
            ordini effettuati in precedenza.
          </p>
          <p class="cn">
            我们的产品价格可能随时变更，恕不另行通知。我们保留随时修改或中止服务或其任何部分或内容的权利，恕不另行通知。对于价格变更或调整，我们不对用户或第三方承担责任。价格变更不影响此前已下的订单。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">4</span>
          <span class="t">
            <span class="it">Effettuazione dell'ordine</span>
            <span class="cn">下单</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED ha il diritto di modificare i
            prezzi e correggere eventuali prezzi errati in tutti gli ordini,
            così come nelle vendite finali. Se un prezzo è errato, ciò potrà
            comportare l'annullamento dell'acquisto da parte di ADVANCING
            DIGITAL TRADE CO., LIMITED e la restituzione dell'importo pagato nel
            modo più opportuno. Tale operazione potrà essere effettuata in
            qualsiasi momento.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            有权修改所有订单及最终销售中的价格，并纠正错误价格。若价格有误，ADVANCING
            DIGITAL TRADE CO., LIMITED
            可取消购买并以最合适的方式退还已付款项。该操作可随时进行。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Gli ordini effettuati a nome di un'altra persona senza il suo
            consenso saranno comunicati alle autorità competenti.
          </p>
          <p class="cn">
            未经他人同意而以其名义下的订单将报告给有关主管部门。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            L'effettuazione dell'ordine può essere subordinata
            all'identificazione e registrazione sul sito web tramite nome utente
            e password.
          </p>
          <p class="cn">
            下单可能须以用户名和密码在网站上完成身份识别和注册。
          </p>
        </div>
        <div class="bi">
          <p class="it lead">
            Si informa che, in conformità alla normativa applicabile in materia
            di commercio elettronico e tutela dei consumatori, la procedura di
            acquisto seguirà i seguenti passaggi:
          </p>
          <p class="cn">
            兹告知，根据适用的电子商务及消费者保护法规，购买流程将按以下步骤进行：
          </p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >Registrazione mediante nome utente e password.</span
            >
            <span class="cn">通过用户名和密码注册。</span>
          </li>
          <li>
            <span class="it"
              >Scelta del prodotto cliccando su "aggiungi al carrello", che
              verrà automaticamente aggiunto al carrello.</span
            >
            <span class="cn"
              >点击 "加入购物车" 选择产品，产品将自动加入购物车。</span
            >
          </li>
          <li>
            <span class="it"
              >Se si desidera aggiungere altri prodotti, sarà possibile farlo.
              Se per errore è stato aggiunto un prodotto non desiderato, sarà
              necessario cliccare sull'opzione per eliminarlo dal
              carrello.</span
            >
            <span class="cn"
              >如需添加其他产品，可继续操作。若误添加了不需要的产品，须点击相应选项将其从购物车中删除。</span
            >
          </li>
          <li>
            <span class="it"
              >Una volta scelto il prodotto o i prodotti, sarà necessario
              cliccare sulla scheda "continua" per procedere all'acquisto.
              Cliccando su tale opzione, apparirà la conferma dell'acquisto,
              ovvero il riepilogo dell'ordine effettuato.</span
            >
            <span class="cn"
              >选定产品后，须点击 "继续"
              选项卡以进行购买。点击该选项后，将显示购买确认，即所下订单的摘要。</span
            >
          </li>
          <li>
            <span class="it"
              >Sarà necessario accettare, mediante selezione delle apposite
              caselle, la Politica sulla Privacy e le presenti Condizioni
              Generali di Acquisto. Una volta completato questo passaggio, sarà
              possibile continuare con il pagamento, selezionando la modalità di
              pagamento.</span
            >
            <span class="cn"
              >须勾选相应选项，接受隐私政策及本通用购买条款。完成此步骤后，可选择付款方式继续付款。</span
            >
          </li>
          <li>
            <span class="it"
              >Per completare il processo, sarà necessario cliccare sul pulsante
              "Finalizza l'ordine".</span
            >
            <span class="cn">要完成流程，须点击 "完成订单" 按钮。</span>
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            Una volta completato l'ordine, l'Utente riceverà all'indirizzo
            e-mail indicato una conferma dell'ordine.
          </p>
          <p class="cn">
            订单完成后，用户将在所填写的电子邮箱收到订单确认。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il processo di acquisto può essere soggetto a modifiche. La
            piattaforma di acquisto del prestatore informerà l'Utente, una volta
            completata la procedura di acquisto, tramite posta elettronica,
            riguardo a tutte le caratteristiche, prezzo, modalità di trasporto,
            data di acquisto e stima di consegna del prodotto acquistato.
          </p>
          <p class="cn">
            购买流程可能有所调整。购买完成后，服务提供方的购买平台将通过电子邮件告知用户所购产品的全部特征、价格、运输方式、购买日期及预计交付时间。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Si prega di controllare la cartella spam e posta indesiderata della
            propria casella e-mail e di verificare sempre che i dati di consegna
            e i dati personali siano corretti.
          </p>
          <p class="cn">
            请检查邮箱的垃圾邮件和垃圾文件夹，并始终确认收货信息和个人数据是否正确。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Qualora vi fosse qualsiasi tipo di errore nell'indirizzo indicato o
            in qualsiasi altro punto dell'ordine, l'Utente dovrà comunicarlo
            immediatamente all'indirizzo e-mail indicato sul sito web, affinché
            si possa procedere alla correzione dell'errore.
          </p>
          <p class="cn">
            若所填地址或订单任何其他信息存在错误，用户须立即通过网站上注明的电子邮箱告知，以便纠正错误。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Per qualsiasi dubbio è possibile contattare il nostro servizio di
            Assistenza Clienti tramite uno qualsiasi dei metodi indicati sul
            sito web. ADVANCING DIGITAL TRADE CO., LIMITED fornirà assistenza
            clienti gratuitamente tramite il nostro indirizzo e-mail di contatto
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>.
            Qualora l'Utente scelga un altro mezzo di comunicazione alternativo,
            dovrà farsi carico del relativo costo.
          </p>
          <p class="cn">
            如有任何疑问，可通过网站上注明的任一方式联系我们的客户服务。ADVANCING
            DIGITAL TRADE CO., LIMITED 将通过联系邮箱
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>
            免费提供客户服务。若用户选择其他替代沟通方式，相关费用由用户自行承担。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">5</span>
          <span class="t">
            <span class="it">Diritto di recesso</span>
            <span class="cn">撤回权</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Nel caso specifico di ADVANCING DIGITAL TRADE CO., LIMITED,
            trattandosi di importazioni specifiche su richiesta del cliente da
            un Paese terzo al di fuori dello Spazio Economico Europeo, la
            cancellazione dell'acquisto potrà essere effettuata esclusivamente
            secondo le politiche offerte dai produttori.
          </p>
          <p class="cn">
            就 ADVANCING DIGITAL TRADE CO., LIMITED
            而言，由于系应客户要求从欧洲经济区以外的第三国进行的特定进口，取消购买仅可按生产商提供的政策执行。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il cliente può richiedere a ADVANCING DIGITAL TRADE CO., LIMITED di
            agire come intermediario nelle trattative con il venditore;
            tuttavia, ADVANCING DIGITAL TRADE CO., LIMITED non assume alcuna
            responsabilità per i risultati finali di tali trattative. Tutti i
            costi associati alla risoluzione del problema saranno a carico del
            cliente. Il cliente dovrà confermare con il venditore la possibilità
            di restituzione o sostituzione del prodotto e sarà responsabile
            delle spese di spedizione nazionali generate, indipendentemente
            dalla quantità o dal fatto che la merce sia difettosa.
          </p>
          <p class="cn">
            客户可要求 ADVANCING DIGITAL TRADE CO., LIMITED
            在与卖方的谈判中充当中介；但 ADVANCING DIGITAL TRADE CO., LIMITED
            对谈判最终结果不承担任何责任。解决问题所产生的全部费用由客户承担。客户须与卖方确认产品可否退货或换货，并承担所产生的国内运费，无论数量多少或货物是否有缺陷。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Inviare un'e-mail a
            <a href="mailto:service@rakumart.it">service@rakumart.it</a> e
            forniremo le istruzioni per restituire il prodotto. L'orario del
            servizio clienti sarà dal lunedì al venerdì, dalle ore 09:00 alle
            ore 18:00. Per la cancellazione dell'ordine o la sua modifica potrà
            essere utilizzata anche la chat installata sulla piattaforma.
          </p>
          <p class="cn">
            请发送电子邮件至
            <a href="mailto:service@rakumart.it">service@rakumart.it</a
            >，我们将提供退货说明。客户服务时间为周一至周五 09:00 至
            18:00。也可使用平台内安装的聊天功能取消或修改订单。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            In caso di restituzione per difetto della merce, il prodotto dovrà
            essere restituito con tutti gli elementi con cui è stato consegnato
            e non dovrà mostrare segni di uso improprio o diverso dalla natura
            propria del bene, all'indirizzo che sarà fornito.
          </p>
          <p class="cn">
            因货物缺陷而退货时，产品须连同交付时的全部附件一并退回，且不得有不当使用或与物品性质不符的使用痕迹，并退回至我们将提供的地址。
          </p>
        </div>
        <div class="bi">
          <p class="it lead">
            Si tenga presente che la restituzione della merce non sarà accettata
            nei seguenti casi:
          </p>
          <p class="cn">请注意，以下情况下不接受退货：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >guasti o danni causati da uso improprio o negligenza, come urti,
              ammaccature, schiacciamenti, ecc.;</span
            >
            <span class="cn"
              >因不当使用或疏忽造成的故障或损坏，如撞击、凹陷、挤压等；</span
            >
          </li>
          <li>
            <span class="it"
              >guasti o danni causati da riparazioni o modifiche non
              giustificate;</span
            >
            <span class="cn">因无正当理由的维修或改装造成的故障或损坏；</span>
          </li>
          <li>
            <span class="it"
              >guasti o danni causati da fuoco, acqua o calamità naturali come
              terremoti;</span
            >
            <span class="cn"
              >因火灾、水灾或地震等自然灾害造成的故障或损坏；</span
            >
          </li>
          <li>
            <span class="it"
              >modifiche estetiche derivanti dal normale uso, dall'usura e
              dall'invecchiamento;</span
            >
            <span class="cn">因正常使用、磨损和老化产生的外观变化；</span>
          </li>
          <li>
            <span class="it"
              >assenza dell'indicazione del negozio e della data di acquisto
              nella garanzia, oppure alterazione di tali informazioni.</span
            >
            <span class="cn"
              >保修单上缺少商店名称和购买日期，或相关信息被涂改。</span
            >
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            La presente garanzia assicura la possibilità di ricevere una
            sostituzione gratuita conformemente ai termini stabiliti nel
            presente documento ed entro il termine indicato, senza limitare
            alcun diritto legale del cliente.
          </p>
          <p class="cn">
            本保修保证客户有权在本文件规定的条款和期限内获得免费更换，且不影响客户依法享有的任何权利。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">6</span>
          <span class="t">
            <span class="it">Conferma</span>
            <span class="cn">确认</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Una volta ricevuto l'ordine, invieremo una conferma all'indirizzo
            e-mail indicato. È pertanto importante fornire un indirizzo e-mail
            reale al momento dell'ordine. Conservare tale e-mail per poter
            contattare il servizio clienti in caso di necessità. La conferma
            dell'ordine, ovvero la ricevuta, funge anche da prova di acquisto.
          </p>
          <p class="cn">
            收到订单后，我们将向所填电子邮箱发送确认邮件。因此，下单时提供真实有效的电子邮箱十分重要。请保存该邮件，以便需要时联系客户服务。订单确认（即收据）亦可作为购买凭证。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">7</span>
          <span class="t">
            <span class="it">Pagamento</span>
            <span class="cn">付款</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it lead">
            Gli ordini effettuati nel nostro negozio online possono essere
            pagati mediante:
          </p>
          <p class="cn">在我们在线商店下的订单可通过以下方式付款：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it">carta di credito/debito;</span>
            <span class="cn">信用卡/借记卡；</span>
          </li>
          <li>
            <span class="it">bonifico bancario.</span>
            <span class="cn">银行转账。</span>
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            Garantiamo elevati standard di sicurezza grazie al protocollo
            crittografico più avanzato, SSL, Secure Sockets Layer. Questo
            sistema ci permette di proteggere i dati personali da accessi non
            autorizzati.
          </p>
          <p class="cn">
            我们采用最先进的加密协议 SSL（Secure Sockets
            Layer）保障高安全标准。该系统可防止个人数据遭受未经授权的访问。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il pagamento tramite bonifico bancario sarà effettuato sul conto
            bancario intestato a ADVANCING DIGITAL TRADE CO., LIMITED.
          </p>
          <p class="cn">
            银行转账付款将汇入 ADVANCING DIGITAL TRADE CO., LIMITED
            名下的银行账户。
          </p>
        </div>
        <div class="bi">
          <p class="it">La valuta di pagamento sarà sempre l'EURO.</p>
          <p class="cn">付款货币始终为欧元（EURO）。</p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">8</span>
          <span class="t">
            <span class="it">Informazioni personali</span>
            <span class="cn">个人信息</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Quando viene effettuato un acquisto, ADVANCING DIGITAL TRADE CO.,
            LIMITED conserverà parte dei dati dell'Utente per completare
            l'acquisto. ADVANCING DIGITAL TRADE CO., LIMITED tratta tutte le
            informazioni personali in modo riservato.
          </p>
          <p class="cn">
            进行购买时，ADVANCING DIGITAL TRADE CO., LIMITED
            将保存用户的部分数据以完成购买。ADVANCING DIGITAL TRADE CO., LIMITED
            对所有个人信息予以保密处理。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            L'Utente ha il diritto di richiedere l'accesso ai propri dati e,
            qualora contengano errori, potrà effettuare le modifiche necessarie
            o richiederne la cancellazione. ADVANCING DIGITAL TRADE CO., LIMITED
            può inoltre utilizzare cookie, ad esempio, per migliorare
            l'esperienza dell'Utente sul sito web.
          </p>
          <p class="cn">
            用户有权要求访问其个人数据；若数据有误，可进行必要修改或要求删除。ADVANCING
            DIGITAL TRADE CO., LIMITED 还可使用
            Cookie，例如用于改善用户在网站上的体验。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            È possibile ottenere maggiori informazioni sulle modalità con cui
            ADVANCING DIGITAL TRADE CO., LIMITED utilizza i dati personali nella
            politica sulla privacy disponibile sul sito web
            <a href="/">www.rakumart.it</a>.
          </p>
          <p class="cn">
            有关 ADVANCING DIGITAL TRADE CO., LIMITED
            如何使用个人数据的更多信息，请参阅网站
            <a href="/">www.rakumart.it</a> 上的隐私政策。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">9</span>
          <span class="t">
            <span class="it">Prodotto</span>
            <span class="cn">产品</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED ha il diritto di modificare i
            prezzi, aggiungere costi supplementari e modificare le informazioni
            sui prodotti, come immagini dei prodotti e offerte, senza preavviso.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            有权随时修改价格、增加附加费用以及修改产品信息（如产品图片和优惠），恕不另行通知。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Le immagini dei prodotti e i testi informativi disponibili
            riflettono il prodotto nella misura più fedele possibile. Ci
            riserviamo il diritto per eventuali errori che possano apparire
            sulla pagina e non possiamo garantire che tutte le immagini
            riflettano esattamente il reale aspetto dei prodotti. Le immagini
            possono variare in funzione delle impostazioni di colore e
            visualizzazione del computer dell'Utente. Tutte le immagini devono
            essere considerate esclusivamente come illustrazioni e non
            garantiscono l'aspetto né le caratteristiche del prodotto.
          </p>
          <p class="cn">
            产品图片及可用说明文字尽可能真实地反映产品。我们保留对页面上可能出现的错误进行处理的权利，且无法保证所有图片与产品实际外观完全一致。图片可能因用户计算机的颜色和显示设置而有所不同。所有图片仅作示意之用，不保证产品的外观或特性。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            I prodotti offerti sul sito web corrispondono a una varietà di
            prodotti disponibili, con possibilità che in futuro vengano offerti
            prodotti o servizi diversi.
          </p>
          <p class="cn">
            网站上提供的产品对应现有多种产品，未来也可能提供不同的产品或服务。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">10</span>
          <span class="t">
            <span class="it">Garanzie applicabili e servizi post-vendita</span>
            <span class="cn">适用售后服务</span>
          </span>
        </h2>
        <div class="group-label">
          <span class="it">10.1 Garanzia legale di conformità</span>
          <span class="cn">10.1 法定合规保修</span>
        </div>
        <div class="bi">
          <p class="it">
            Tutti i prodotti venduti a consumatori sono coperti dalla garanzia
            legale di conformità prevista dal Codice del Consumo italiano. La
            garanzia legale ha durata di 2 anni dalla consegna del bene e tutela
            il consumatore in caso di difetto di conformità esistente al momento
            della consegna o manifestatosi entro il periodo previsto dalla
            legge.
          </p>
          <p class="cn">
            向消费者销售的所有产品均受意大利《消费者法典》规定的法定合规保修保障。法定保修自货物交付之日起为期
            2
            年，保护消费者免受交付时已存在或在法律规定的期限内显现的合规缺陷之害。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            La garanzia legale si applica indipendentemente da eventuali
            garanzie commerciali offerte dal produttore o dal venditore.
            Eventuali garanzie commerciali aggiuntive saranno indicate
            separatamente e non limitano in alcun modo i diritti riconosciuti al
            consumatore dalla legge.
          </p>
          <p class="cn">
            法定保修的适用不受生产商或卖方提供的任何商业保修影响。任何附加商业保修将另行注明，且绝不限制法律赋予消费者的权利。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il diritto alla garanzia legale è applicabile quando il difetto non
            deriva da uso improprio, installazione errata, manutenzione non
            conforme alle istruzioni, normale usura del prodotto, danni
            accidentali o interventi effettuati da soggetti non autorizzati.
          </p>
          <p class="cn">
            当缺陷并非因不当使用、错误安装、未按说明维护、产品正常磨损、意外损坏或由未经授权的人员进行干预所致时，方可适用法定保修。
          </p>
        </div>
        <div class="group-label">
          <span class="it"
            >10.2 Rimedi in caso di prodotto difettoso o non conforme</span
          >
          <span class="cn">10.2 产品有缺陷或不合规时的救济</span>
        </div>
        <div class="bi">
          <p class="it">
            In caso di prodotto difettoso o non conforme, il consumatore ha
            diritto, senza spese, al ripristino della conformità del bene
            mediante riparazione o sostituzione, secondo quanto previsto dalla
            normativa applicabile.
          </p>
          <p class="cn">
            若产品有缺陷或不合规，消费者有权根据适用法规，免费通过维修或更换使产品恢复合规。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Qualora la riparazione o la sostituzione siano impossibili,
            eccessivamente onerose o non vengano effettuate entro un termine
            congruo, il consumatore potrà avere diritto alla riduzione
            proporzionale del prezzo o alla risoluzione del contratto, nei casi
            e nei limiti previsti dalla legge.
          </p>
          <p class="cn">
            若维修或更换不可能、成本过高，或未在合理期限内完成，消费者可依法在法律规定的情形和范围内要求按比例降价或解除合同。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Per segnalare un difetto di conformità, il cliente può contattare il
            servizio clienti all'indirizzo e-mail
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>,
            indicando il numero d'ordine, una descrizione del problema e, se
            possibile, fotografie o video che mostrino il difetto riscontrato.
          </p>
          <p class="cn">
            如需报告合规缺陷，客户可发送电子邮件至
            <a href="mailto:service@rakumart.it">service@rakumart.it</a>
            联系客户服务，注明订单号、问题描述，并尽可能附上显示所发现缺陷的照片或视频。
          </p>
        </div>
        <div class="group-label">
          <span class="it"
            >10.3 Prodotti ricevuti per errore o danneggiati durante il
            trasporto</span
          >
          <span class="cn">10.3 错发或运输中损坏的产品</span>
        </div>
        <div class="bi">
          <p class="it">
            Qualora il prodotto ricevuto non corrisponda a quello ordinato a
            causa di un errore imputabile a ADVANCING DIGITAL TRADE CO.,
            LIMITED, il cliente dovrà comunicarlo al servizio clienti il prima
            possibile. In tali casi, ADVANCING DIGITAL TRADE CO., LIMITED
            provvederà, secondo quanto applicabile, al ritiro del prodotto
            inviato per errore e alla consegna del prodotto corretto, senza
            costi aggiuntivi per il cliente.
          </p>
          <p class="cn">
            若因 ADVANCING DIGITAL TRADE CO., LIMITED
            的过错导致收到的产品与订购产品不符，客户应尽快通知客户服务。在此情况下，ADVANCING
            DIGITAL TRADE CO., LIMITED
            将视情况取回错发产品并交付正确产品，不向客户收取额外费用。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            In caso di prodotto danneggiato durante il trasporto, il cliente è
            invitato a conservare l'imballaggio originale e a inviare al
            servizio clienti fotografie del pacco, dell'etichetta di spedizione
            e del prodotto danneggiato, così da consentire una corretta gestione
            della pratica con il corriere.
          </p>
          <p class="cn">
            若产品在运输过程中损坏，建议客户保留原包装，并向客户服务发送包裹、运输标签及损坏产品的照片，以便与快递公司妥善处理相关事宜。
          </p>
        </div>
        <div class="group-label">
          <span class="it">10.4 Esclusioni dalla garanzia</span>
          <span class="cn">10.4 保修除外情形</span>
        </div>
        <div class="bi">
          <p class="it lead">
            La garanzia legale non copre difetti o danni causati da:
          </p>
          <p class="cn">法定保修不涵盖由以下原因造成的缺陷或损坏：</p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >uso improprio, negligente o non conforme alle istruzioni del
              prodotto;</span
            >
            <span class="cn">不当、疏忽或未按产品说明使用；</span>
          </li>
          <li>
            <span class="it"
              >installazione, montaggio o manutenzione non corretti;</span
            >
            <span class="cn">安装、组装或维护不当；</span>
          </li>
          <li>
            <span class="it"
              >urti, cadute, schiacciamenti, manomissioni o modifiche non
              autorizzate;</span
            >
            <span class="cn">撞击、跌落、挤压、篡改或未经授权的改装；</span>
          </li>
          <li>
            <span class="it"
              >riparazioni effettuate da soggetti non autorizzati;</span
            >
            <span class="cn">由未经授权的人员进行的维修；</span>
          </li>
          <li>
            <span class="it"
              >normale usura del prodotto o dei suoi componenti
              consumabili;</span
            >
            <span class="cn">产品或其消耗性部件的正常磨损；</span>
          </li>
          <li>
            <span class="it"
              >cause esterne non imputabili a ADVANCING DIGITAL TRADE CO.,
              LIMITED, quali incendi, allagamenti, eventi atmosferici, sbalzi
              elettrici, incidenti o altri eventi di forza maggiore;</span
            >
            <span class="cn"
              >不可归责于 ADVANCING DIGITAL TRADE CO., LIMITED
              的外部原因，如火灾、水灾、恶劣天气、电压波动、事故或其他不可抗力事件；</span
            >
          </li>
          <li>
            <span class="it"
              >utilizzo del prodotto in ambito professionale, intensivo o
              comunque diverso dall'uso ordinario previsto, salvo che tale uso
              sia stato espressamente indicato come compatibile nella scheda
              prodotto.</span
            >
            <span class="cn"
              >将产品用于专业、高强度或与预期普通用途不同的场景，除非产品说明中明确表示该用途兼容。</span
            >
          </li>
        </ul>
        <div class="group-label">
          <span class="it">10.5 Garanzia commerciale</span>
          <span class="cn">10.5 商业保修</span>
        </div>
        <div class="bi">
          <p class="it">
            Eventuali garanzie commerciali o convenzionali offerte dal
            produttore o da ADVANCING DIGITAL TRADE CO., LIMITED saranno valide
            esclusivamente nei termini, nella durata e nelle modalità indicate
            nella relativa documentazione. Tali garanzie commerciali si
            aggiungono alla garanzia legale e non la sostituiscono né la
            limitano.
          </p>
          <p class="cn">
            生产商或 ADVANCING DIGITAL TRADE CO., LIMITED
            提供的任何商业或约定保修，仅在相关文件注明的条款、期限和方式内有效。此类商业保修是对法定保修的补充，不替代也不限制法定保修。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">11</span>
          <span class="t">
            <span class="it">Logistica, consegna e cancellazioni</span>
            <span class="cn">物流、交付与取消</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED effettua spedizioni sul
            territorio nazionale. I tempi di consegna sono indicativi e
            ADVANCING DIGITAL TRADE CO., LIMITED non sarà responsabile di
            eventuali ritardi rispetto ai tempi stimati, salvo i diritti
            inderogabili riconosciuti al consumatore dalla normativa
            applicabile; il ritardo nei tempi di consegna non costituirà
            automaticamente motivo valido per la cancellazione dell'ordine,
            fatto salvo quanto previsto dalla legge.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            在意大利全国境内发货。交付时间为参考时间，ADVANCING DIGITAL TRADE
            CO., LIMITED
            对超出预计时间的延迟不承担责任，但适用法规赋予消费者的不可剥夺权利除外；交付延迟本身不构成自动取消订单的正当理由，法律另有规定的除外。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Una volta effettuato l'acquisto tramite la piattaforma web
            <a href="/">www.rakumart.it</a>, viene elaborato un preventivo
            stimato di spedizione entro 24 ore dal pagamento della merce. Una
            volta effettuato tale pagamento, la merce viene trasportata presso i
            magazzini di proprietà di ADVANCING DIGITAL TRADE CO., LIMITED, dove
            verrà eseguito un controllo qualità e la manipolazione della merce.
          </p>
          <p class="cn">
            通过网站平台 <a href="/">www.rakumart.it</a>
            完成购买后，将在货款支付后 24
            小时内出具预计运费报价。货款支付完成后，货物将运至 ADVANCING DIGITAL
            TRADE CO., LIMITED 自有仓库，进行质量检查和货物处理。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Una volta verificato il buono stato della merce, verrà effettuato il
            pagamento della spedizione e la consegna. Prima della consegna, il
            cliente e ADVANCING DIGITAL TRADE CO., LIMITED concorderanno la
            modalità di consegna.
          </p>
          <p class="cn">
            确认货物状态良好后，将支付运费并完成交付。交付前，客户与 ADVANCING
            DIGITAL TRADE CO., LIMITED 将协商交付方式。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Le restituzioni degli acquisti saranno soggette alle politiche di
            reso stabilite dal produttore. La cancellazione dell'acquisto potrà
            essere effettuata esclusivamente secondo le politiche offerte dai
            produttori.
          </p>
          <p class="cn">
            购买退货须遵守生产商制定的退货政策。取消购买仅可按生产商提供的政策执行。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il cliente può richiedere a ADVANCING DIGITAL TRADE CO., LIMITED di
            agire come intermediario nelle trattative con il venditore;
            tuttavia, ADVANCING DIGITAL TRADE CO., LIMITED non assume alcuna
            responsabilità per i risultati finali di tali trattative. Tutti i
            costi associati alla risoluzione del problema saranno a carico del
            cliente. Il cliente dovrà confermare con il venditore la possibilità
            di restituzione o sostituzione del prodotto e sarà responsabile
            delle spese di spedizione nazionali generate, indipendentemente
            dalla quantità o dal fatto che la merce sia difettosa.
          </p>
          <p class="cn">
            客户可要求 ADVANCING DIGITAL TRADE CO., LIMITED
            在与卖方的谈判中充当中介；但 ADVANCING DIGITAL TRADE CO., LIMITED
            对谈判最终结果不承担任何责任。解决问题所产生的全部费用由客户承担。客户须与卖方确认产品可否退货或换货，并承担所产生的国内运费，无论数量多少或货物是否有缺陷。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">12</span>
          <span class="t">
            <span class="it">Disponibilità dei prodotti</span>
            <span class="cn">产品库存</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Potrebbero verificarsi situazioni in cui non sia possibile fornire
            tutti i prodotti perché non disponibili in stock al momento
            dell'acquisto. In tali casi, il personale di ADVANCING DIGITAL TRADE
            CO., LIMITED contatterà l'Utente per offrire le seguenti opzioni:
          </p>
          <p class="cn">
            可能出现因购买时库存不足而无法供应全部产品的情况。在此情况下，ADVANCING
            DIGITAL TRADE CO., LIMITED 的工作人员将联系用户并提供以下选项：
          </p>
        </div>
        <ul class="bi-list">
          <li>
            <span class="it"
              >scelta di un prodotto alternativo con caratteristiche simili al
              prodotto da sostituire;</span
            >
            <span class="cn">选择与被替换产品特性相似的替代产品；</span>
          </li>
          <li>
            <span class="it"
              >comunicazione della futura disponibilità, qualora l'Utente
              preferisca attendere che il prodotto torni disponibile nel
              negozio.</span
            >
            <span class="cn"
              >告知未来到货时间，若用户愿意等待产品重新上架。</span
            >
          </li>
        </ul>
        <div class="bi">
          <p class="it">
            Qualora l'Utente rifiuti le nostre proposte, l'ordine relativo a
            tali prodotti sarà annullato e verrà restituita qualsiasi somma
            eventualmente pagata.
          </p>
          <p class="cn">
            若用户拒绝我们的建议，相关产品的订单将被取消，已支付的款项将予以退还。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">13</span>
          <span class="t">
            <span class="it">Condizioni di reclamo</span>
            <span class="cn">投诉条件</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            È importante che il cliente controlli attentamente i prodotti al
            momento della ricezione della spedizione, al fine di verificare che
            non siano danneggiati e che siano corretti.
          </p>
          <p class="cn">
            客户须在收到货物时仔细检查产品，确认其未损坏且与订购内容一致。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Se il prodotto subisce danni durante il trasporto, sia visibili che
            nascosti, il cliente dovrà comunicarlo il prima possibile. Se al
            momento della ricezione dell'articolo si riscontra che è danneggiato
            o non corrisponde a quello ordinato, è necessario contattarci entro
            un termine massimo di 30 giorni dalla data di ricezione del
            prodotto.
          </p>
          <p class="cn">
            若产品在运输过程中发生可见或隐蔽损坏，客户应尽快告知。若收货时发现产品损坏或与订购不符，须在收到产品之日起最多
            30 天内联系我们。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Tutti i reclami dovranno essere indirizzati al nostro servizio
            clienti tramite la chat disponibile sul sito web o tramite posta
            elettronica all'indirizzo indicato al punto 1 delle presenti
            condizioni generali di contratto, fornendo il numero d'ordine e il
            motivo del reclamo. Provvederemo a contattare il cliente nel più
            breve tempo possibile.
          </p>
          <p class="cn">
            所有投诉须通过网站聊天功能或发送电子邮件至本通用合同条款第 1
            条注明的地址提交至我们的客户服务，并提供订单号及投诉原因。我们将尽快联系客户。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Lo stesso procedimento deve essere seguito in caso di restituzione.
            I prodotti difettosi restituiti a ADVANCING DIGITAL TRADE CO.,
            LIMITED devono essere trattati come se non presentassero difetti. È
            estremamente importante che, in tutte le restituzioni, il prodotto
            venga imballato in modo tale da non subire danni durante il
            trasporto.
          </p>
          <p class="cn">
            退货时须遵循相同程序。退回 ADVANCING DIGITAL TRADE CO., LIMITED
            的缺陷产品应视同无缺陷产品处理。所有退货中，产品包装须足以避免运输过程中再次受损，这一点极为重要。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED ha il diritto di sostituire i
            prodotti difettosi con altri prodotti dello stesso modello. Se
            l'articolo è fuori produzione, il cliente riceverà il rimborso
            dell'intero importo pagato. Qualora il prodotto restituito non
            presenti errori o difetti, ADVANCING DIGITAL TRADE CO., LIMITED
            rispedirà il prodotto al cliente.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            有权以同型号其他产品替换缺陷产品。若该商品已停产，客户将获得全额退款。若退回产品并无错误或缺陷，ADVANCING
            DIGITAL TRADE CO., LIMITED 将把产品重新寄回给客户。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">14</span>
          <span class="t">
            <span class="it">Responsabilità</span>
            <span class="cn">责任</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            La responsabilità di ADVANCING DIGITAL TRADE CO., LIMITED per errori
            nella consegna è limitata alle condizioni di vendita in vigore.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            对交付错误的责任以当时有效的销售条件为限。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED non assume alcuna
            responsabilità diretta o indiretta, a titolo esemplificativo ma non
            esaustivo, per incompatibilità, ritardi nella consegna, tempi di
            inattività, perdita di dati, lavori aggiuntivi o altri danni
            economici.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            对兼容性问题、交付延迟、停机时间、数据丢失、额外工作或其他经济损失等，不承担任何直接或间接责任（举例说明，但不限于上述情形）。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            La responsabilità civile di ADVANCING DIGITAL TRADE CO., LIMITED per
            i prodotti e servizi forniti è limitata all'importo degli stessi.
            L'Utente rinuncia a reclamare qualsiasi responsabilità nei confronti
            del prestatore, per qualsiasi motivo, in caso di insoddisfazione
            relativa ai prodotti acquistati sul sito web, nonché per eventuali
            malfunzionamenti, lentezza di accesso o errori nell'accesso alla
            pagina web, incluse perdite di dati o altre informazioni presenti
            nel computer o nella rete dell'Utente che accede alla piattaforma.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            对所提供产品和服务的民事责任以相应金额为限。用户对在网站上购买的产品感到不满，或因网站故障、访问缓慢、网页访问错误（包括访问用户计算机或网络中存储的数据或其他信息时发生的数据丢失）而向服务提供方主张任何责任，均予以放弃。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">15</span>
          <span class="t">
            <span class="it">Forza maggiore</span>
            <span class="cn">不可抗力</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED sarà esente da responsabilità
            per danni, perdite o altre sanzioni qualora l'esecuzione del
            contratto sia impedita, ostacolata o ritardata da circostanze al di
            fuori del nostro controllo.
          </p>
          <p class="cn">
            若合同履行因超出我们控制范围的情况而受到阻碍、妨碍或延迟，ADVANCING
            DIGITAL TRADE CO., LIMITED
            对由此产生的损害、损失或其他责任予以免责。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Tra i fattori di esonero devono essere inclusi, a titolo
            esemplificativo, interventi governativi, nuove leggi o modifiche
            legislative, assenza di Stato, guerra, incendi, inondazioni,
            conflitti lavorativi, divieti, restrizioni, sabotaggio, carenze nel
            trasporto, condizioni meteorologiche, mancata consegna da parte dei
            fornitori e l'esposizione dell'azienda ad attività criminali che
            incidano sulle sue attività.
          </p>
          <p class="cn">
            免责因素包括但不限于：政府干预、新法律或立法变更、无政府状态、战争、火灾、洪水、劳资冲突、禁令、限制、破坏活动、运输短缺、天气条件、供应商未交付，以及企业遭受影响其经营活动的犯罪行为。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">16</span>
          <span class="t">
            <span class="it">Diritti di proprietà intellettuale</span>
            <span class="cn">知识产权</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Tutti i diritti di proprietà intellettuale, quali marchi commerciali
            e diritti d'autore, che compaiono sul sito web e nel materiale
            pubblicato, sono di proprietà di ADVANCING DIGITAL TRADE CO.,
            LIMITED o delle sue controllate o licenzianti.
          </p>
          <p class="cn">
            网站及已发布材料中出现的所有知识产权（如商标和著作权）均归 ADVANCING
            DIGITAL TRADE CO., LIMITED 或其关联公司或许可方所有。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Qualsiasi utilizzo del sito o del suo contenuto, inclusa la copia o
            la memorizzazione di tale contenuto, in tutto o in parte, per
            finalità diverse dall'uso personale e non commerciale, è vietato
            senza il consenso di ADVANCING DIGITAL TRADE CO., LIMITED.
          </p>
          <p class="cn">
            未经 ADVANCING DIGITAL TRADE CO., LIMITED
            同意，禁止以个人非商业用途以外的任何目的使用网站或其内容，包括全部或部分复制或存储该内容。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">17</span>
          <span class="t">
            <span class="it">Frode</span>
            <span class="cn">欺诈</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Tutte le frodi saranno denunciate alle autorità competenti e
            ADVANCING DIGITAL TRADE CO., LIMITED si riserva il diritto di
            annullare l'acquisto qualora vi sia qualsiasi sospetto in tal senso.
          </p>
          <p class="cn">
            一切欺诈行为将报告给有关主管部门，ADVANCING DIGITAL TRADE CO.,
            LIMITED 保留在存在任何相关嫌疑时取消购买的权利。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">18</span>
          <span class="t">
            <span class="it">Risoluzione</span>
            <span class="cn">解除</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED si riserva il diritto di
            cancellare l'account dell'Utente e/o vietargli l'utilizzo del sito
            web
            <a href="/">www.rakumart.it</a> a propria esclusiva discrezione.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED
            保留自行决定注销用户账户和/或禁止其使用网站
            <a href="/">www.rakumart.it</a> 的权利。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Ciò potrà avvenire, ad esempio, qualora ADVANCING DIGITAL TRADE CO.,
            LIMITED sospetti che l'Utente abbia violato le presenti Condizioni
            d'uso. Tale risoluzione potrà essere effettuata senza preavviso.
          </p>
          <p class="cn">
            例如，若 ADVANCING DIGITAL TRADE CO., LIMITED
            怀疑用户违反了本使用条款，即可采取上述措施。此类解除可不经事先通知。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">19</span>
          <span class="t">
            <span class="it">Modifiche</span>
            <span class="cn">修改</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            ADVANCING DIGITAL TRADE CO., LIMITED potrà aggiornare periodicamente
            le presenti Condizioni d'uso.
          </p>
          <p class="cn">
            ADVANCING DIGITAL TRADE CO., LIMITED 可定期更新本使用条款。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Ogni volta che l'Utente effettua un ordine presso di noi, sarà
            soggetto alle condizioni generali in vigore al momento della
            formalizzazione del contratto tra l'Utente e ADVANCING DIGITAL TRADE
            CO., LIMITED.
          </p>
          <p class="cn">
            用户每次向我们下单，均受用户与 ADVANCING DIGITAL TRADE CO., LIMITED
            正式订立合同时有效的通用条款约束。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Per questo motivo, l'Utente deve visitare periodicamente questa
            pagina per verificare le condizioni attuali a cui è soggetto.
          </p>
          <p class="cn">
            因此，用户应定期访问本页面，以了解当前适用的条款。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">20</span>
          <span class="t">
            <span class="it">Nullità e inefficacia delle clausole</span>
            <span class="cn">条款无效与失效</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Qualora qualsiasi clausola inclusa nelle presenti Condizioni
            Generali venga dichiarata, totalmente o parzialmente, nulla o
            inefficace, tale nullità o inefficacia riguarderà esclusivamente
            detta disposizione o la parte della stessa che risulti nulla o
            inefficace.
          </p>
          <p class="cn">
            若本通用条款中的任何条款被全部或部分宣告无效或失效，该无效或失效仅涉及该条款本身或其无效或失效的部分。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Le Condizioni Generali resteranno valide per tutto il resto,
            considerando tale disposizione, o la parte interessata, come non
            apposta.
          </p>
          <p class="cn">
            本通用条款的其余部分仍然有效，并视该条款或其受影响部分从未订立。
          </p>
        </div>
      </section>

      <section class="sec">
        <h2 class="sec-title">
          <span class="num">21</span>
          <span class="t">
            <span class="it">Legge applicabile e giurisdizione</span>
            <span class="cn">适用法律与管辖</span>
          </span>
        </h2>
        <div class="bi">
          <p class="it">
            Le presenti condizioni saranno regolate e interpretate conformemente
            alla normativa italiana e, ove applicabile, alla normativa
            dell'Unione Europea in materia di tutela dei consumatori e commercio
            elettronico.
          </p>
          <p class="cn">
            本条款的订立、解释和执行均适用意大利法律，并在适用情况下适用欧盟关于消费者保护和电子商务的法规。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Il prestatore e l'Utente concordano di sottoporre qualsiasi
            controversia che possa sorgere dalla fornitura dei prodotti o
            servizi oggetto delle presenti Condizioni ai Giudici e Tribunali del
            domicilio del prestatore, se persona giuridica, o dell'Utente, se
            persona fisica.
          </p>
          <p class="cn">
            服务提供方与用户同意，因本条款项下产品或服务提供而可能产生的任何争议，提交至服务提供方（若为法人）或用户（若为自然人）住所地有管辖权的法院处理。
          </p>
        </div>
        <div class="bi">
          <p class="it">
            Per i consumatori, il foro competente è quello del luogo di
            residenza o domicilio del consumatore, ove previsto dalla normativa
            applicabile. Per gli Utenti che agiscono per finalità professionali
            o imprenditoriali, salvo diverso accordo scritto tra le parti, sarà
            competente il foro individuato secondo la normativa applicabile.
          </p>
          <p class="cn">
            对于消费者，在适用法规规定的情况下，有管辖权的法院为消费者居住地或住所地法院。对于以专业或经营目的行事的用户，除双方另有书面约定外，有管辖权的法院按适用法规确定。
          </p>
        </div>
      </section>
    </div>
    <Foot style="width: 100%"></Foot>
  </div>
</template>
<script>
import Head from "../../components/head/HomePageTop.vue";
import Foot from "@/components/foot/Foot.vue";
export default {
  data() {
    return {};
  },
  components: { Head, Foot },
  computed: {
    // 根据 store 中的 fanyi 状态切换中意双语显示
    isZh() {
      return !!this.$store.state.fanyi;
    },
  },
  created() {},
  methods: {},
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";

$accent: #009246;

.legal-wrap {
  background: #f4f6f9;
  padding: 0 0 60px;

  &.lang-it .cn {
    display: none !important;
  }

  &.lang-cn .it {
    display: none !important;
  }
}

.page {
  width: 900px;
  margin: 30px auto 60px;
  background: #fff;
  border-radius: 14px;
  box-shadow: 0 8px 30px rgba(20, 30, 60, 0.07);
  padding: 50px 60px 56px;
}

.doc-header {
  text-align: center;
  padding-bottom: 26px;
  border-bottom: 2px solid #f0f2f5;
  margin-bottom: 34px;

  .doc-title {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 6px;

    &.doc-title-single {
      display: block;
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
      text-align: center;
    }

    .it {
      font-size: 30px;
      font-weight: 700;
      color: #1d2129;
      line-height: 1.2;
    }

    .cn {
      font-size: 17px;
      font-weight: 500;
      color: #86909c;
      letter-spacing: 2px;
    }
  }

  .doc-sub {
    margin-top: 14px;
    font-size: 13px;
    color: #a0a8b5;
    letter-spacing: 0.5px;
  }
}

.info-card {
  background: linear-gradient(135deg, #f0faf4 0%, #fff 100%);
  border: 1px solid #c8e6c9;
  border-radius: 10px;
  padding: 18px 24px;
  margin-bottom: 34px;

  .info-row {
    display: flex;
    align-items: center;
    padding: 8px 0;

    & + .info-row {
      border-top: 1px dashed #d4edda;
    }

    .info-label {
      flex: 0 0 220px;
      display: flex;
      flex-direction: column;

      .it {
        font-size: 14px;
        font-weight: 600;
        color: #4e5969;
      }

      .cn {
        font-size: 12px;
        color: #a0a8b5;
      }
    }

    .info-value {
      font-size: 14px;
      color: #1d2129;
      font-weight: 500;

      a {
        color: $accent;
        text-decoration: none;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}

.sec {
  margin-bottom: 36px;

  .sec-title {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .num {
      flex: 0 0 34px;
      height: 34px;
      line-height: 34px;
      text-align: center;
      border-radius: 9px;
      background: $accent;
      color: #fff;
      font-size: 16px;
      font-weight: 700;
      margin-right: 14px;
    }

    .t {
      display: flex;
      flex-direction: column;

      .it {
        font-size: 18px;
        font-weight: 700;
        color: #1d2129;
        line-height: 1.3;
      }

      .cn {
        font-size: 13px;
        color: #86909c;
      }
    }
  }
}

.group-label {
  display: inline-flex;
  flex-direction: column;
  gap: 2px;
  background: #f0faf4;
  border-radius: 8px;
  padding: 8px 14px;
  margin: 8px 0 14px;

  .it {
    font-size: 14px;
    font-weight: 600;
    color: $accent;
  }

  .cn {
    font-size: 12px;
    color: #5a9e72;
  }
}

.bi {
  margin-bottom: 16px;

  .it {
    font-size: 14.5px;
    line-height: 1.75;
    color: #2b303a;
    margin-bottom: 6px;

    &.lead {
      font-weight: 600;
    }

    a {
      color: $accent;
      text-decoration: none;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .cn {
    font-size: 13.5px;
    line-height: 1.75;
    color: #86909c;
  }
}

.bi-list {
  margin: 0 0 18px;
  padding: 0;

  li {
    position: relative;
    list-style: none;
    padding: 10px 16px 10px 30px;
    border-radius: 8px;
    margin-bottom: 8px;
    background: #f7f8fa;

    &::before {
      content: "";
      position: absolute;
      left: 14px;
      top: 19px;
      width: 6px;
      height: 6px;
      border-radius: 50%;
      background: $accent;
    }

    .it {
      display: block;
      font-size: 14px;
      line-height: 1.7;
      color: #2b303a;
    }

    .cn {
      display: block;
      font-size: 13px;
      line-height: 1.7;
      color: #86909c;
      margin-top: 2px;
    }
  }
}
</style>
